module.exports = __webpack_public_path__ + "static/media/8.question.46a4dcc1.mp4";